/* eslint-disable no-console */
import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

class CategoryArea extends React.Component {
  render() {
    const categoryOptions = this.props.categories.map(({ id, title }) => ({ value: id, label: title }))
    const category = this.props.categories.find(category => category.id === this.props.categoryId)
    const subcategoriesOptions = category && category.subcategories
      ? category.subcategories.map(subcategory => ({ value: subcategory.id, label: subcategory.title }))
      : []

    if (!categoryOptions) {
      return null
    }

    return (
      <div className="publisher-area publisher-area--category">
        <div className="card">
          <div className="l-inner">
            <div className="section-heading">Category and subcategory</div>

            <div className="row">
              <div className="col-6 col-sm-5 col-md-4 category-section">
                <div className="form-group form-group-grey">
                  <label>Category <b>*</b></label>
                  <Select
                    ref="categorySelect"
                    className={`Select-outline ${this.props.showErrors && this.props.categoryId === null ? 'is-invalid' : ''}`}
                    id="category-select"
                    placeholder="Choose category"
                    options={categoryOptions}
                    onChange={(data) => data && this.props.handleDetailChange('categoryId', data.value)}
                    value={this.props.categoryId}
                    searchable
                    clearable={false}
                    onOpen={() => { this.refs.categorySelect.focus() }}
                    autoBlur
                  />
                </div>

                {this.props.showErrors && this.props.categoryId === null && (
                  <div className="error-message">Category is required</div>
                )}

                <span className="separator separator--absolute" />
              </div>

              <div className="col-6 col-sm-5 col-md-4">
                <div className="form-group form-group-grey">
                  <label>Subcategory <b>*</b></label>
                  <Select
                    ref="subcategorySelect"
                    className={`Select-outline ${this.props.showErrors && this.props.subcategoryId === null ? 'is-invalid' : ''}`}
                    id="subcategory-select"
                    placeholder="Choose subcategory"
                    disabled={this.props.categoryId === null}
                    options={this.props.categoryId === null || !category ? [] : subcategoriesOptions}
                    onChange={(data) => data && this.props.handleDetailChange('subcategoryId', data.value)}
                    value={this.props.subcategoryId}
                    searchable
                    clearable={false}
                    onOpen={() => { this.refs.subcategorySelect.focus() }}
                    autoBlur
                  />

                  {this.props.showErrors && this.props.subcategoryId === null && (
                    <div className="error-message">Subcategory is required</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

CategoryArea.propTypes = {
  categoryId: PropTypes.number.isRequired,
  subcategoryId: PropTypes.number.isRequired,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      productType: PropTypes.string.isRequired,
      subcategories: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          title: PropTypes.string.isRequired,
          productType: PropTypes.string.isRequired,
        }).isRequired
      ).isRequired,
    }).isRequired
  ).isRequired,
  handleDetailChange: PropTypes.func.isRequired,
  showErrors: PropTypes.bool.isRequired,
}

export default CategoryArea
